module.exports = __webpack_public_path__ + "img/scene-microgrid.3fa18542.jpg";